import React from 'react';
import { AIContactEvaluationOption } from 'utils';
import { NeutralIcon } from 'assets';
import { Typography } from 'antd';
import { aiAgentCenterMessages } from 'messages';
import { useContactDetailByChat } from 'hooks/contacts';
import { ChatSessionDto } from 'types';

type Props = {
  chatSession: ChatSessionDto;
};
const AIAgentChatHeader: React.FC<Props> = ({ chatSession }) => {
  const { contact } = useContactDetailByChat(chatSession?.chatId);
  const aiPreview = contact?.contactSentiment;
  const icon = aiPreview
    ? AIContactEvaluationOption[aiPreview.sentiment as keyof typeof AIContactEvaluationOption]?.icon
    : undefined;

  return (
    <div className='relative flex h-16 items-center border-b px-4'>
      <div className='relative flex w-full items-center gap-2'>
        <div className='absolute left-1/2 flex h-full -translate-x-1/2 flex-col items-center justify-center'>
          <Typography.Text className='mb-0.5 font-semibold'>{chatSession.chat.customerName}</Typography.Text>
          <Typography.Text className='text-sm text-colorTextPlaceholder'>
            {aiAgentCenterMessages.channel}
            <span className='capitalize'> {chatSession.chat.source}</span>
          </Typography.Text>
        </div>
        <div>
          <div className='h-9 w-9'>{icon ? icon?.(36) : <NeutralIcon height={36} width={36} />}</div>
        </div>
      </div>
    </div>
  );
};
export default AIAgentChatHeader;
